// 9fbef606107a605d69c0edbcd8029e5d

const drawStar = (ctx, size, colors) => {
  ctx.beginPath();
  ctx.moveTo(0, -size / 4);
  for (let i = 0; i < 5; i += 1) {
    const angle = (i * 144 * Math.PI) / 180;
    ctx.lineTo((Math.cos(angle) * size) / 2, (Math.sin(angle) * size) / 2);
  }
  ctx.closePath();
  ctx.fillStyle = colors;
  ctx.fill();
};

export default drawStar;
